import { MutableRefObject } from 'react';

const scrollToRef = (ref: MutableRefObject<HTMLElement | null>, param: string) => {
  const urlHashParams = window.location.hash;
  const urlSearchParams = new URLSearchParams(window.location.search);
  const params = Object.fromEntries(urlSearchParams.entries());
  if ((!!params && !!params.scroll) || params.scroll === param || urlHashParams) {
    if (ref.current !== null) {
      ref.current.scrollIntoView();
    }
  }
};

export default scrollToRef;
